import { ErrorBoundary } from 'react-error-boundary';
import { useTranslation } from 'react-i18next';
import { captureRemixErrorBoundaryError } from '@sentry/remix';

import { type SubeventHeaderIndexProps, SubeventHeaderWithQuery } from '@cx-modules/subevent-header';

export const SubeventHeader = (props: SubeventHeaderIndexProps) => {
  const { i18n } = useTranslation();
  return (
    <ErrorBoundary
      fallbackRender={({ error }) => {
        captureRemixErrorBoundaryError(error);
        return null;
      }}
    >
      <SubeventHeaderWithQuery {...props} i18n={i18n} />
    </ErrorBoundary>
  );
};
